import * as types from "./types";

import {
    getQuotationsListAxios,
    deleteQuotationsAxios,
    postQuotationsAxios,
    putQuotationsAxios,
    getQuotationByIdAxios,

    getQuotationDocumentList,
    deleteQuotationDocument,
    uploadQuotationMultipleDocuments,
    uploadQuotationDocument,
    downloadQuotationDocument
} from "./services";

export async function getQuotationsListAction({ commit }) {
    commit(types.LOADING_QUOTATIONS, true);
    try {
        const { data } = await getQuotationsListAxios();
        commit(types.GET_QUOTATIONS_LIST, data.result);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_QUOTATIONS, false);
    }
}

export async function removeQuotationsAction({ commit }, payload) {
    commit(types.LOADING_QUOTATIONS, true);
    try {
        await deleteQuotationsAxios(payload);
        commit(types.REMOVE_QUOTATIONS, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_QUOTATIONS, false);
    }
}

export async function addQuotationsAction({ commit }, payload) {
    commit(types.LOADING_QUOTATIONS, true);
    try {
        const { data } = await postQuotationsAxios(payload);
        commit(types.ADD_QUOTATIONS, data.result);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_QUOTATIONS, false);
    }
}

export async function updateQuotationsAction({ commit }, payload) {
    commit(types.LOADING_QUOTATIONS, true);
    try {
        await putQuotationsAxios(payload);
        commit(types.UPDATE_QUOTATIONS, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_QUOTATIONS, false);
    }
}

export async function getQuotationByIdAction({ commit }, payload) {
    commit(types.LOADING_QUOTATIONS, true);
    try {
        const { data } = await getQuotationByIdAxios(payload);
        commit(types.GET_QUOTATION_ID, data.result);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_QUOTATIONS, false);
    }
}

export async function getQuotationDocumentListAction({ commit },id) {
    commit(types.LOADING_QUOTATION_DOCUMENT, true);
    try {
        const { data } = await getQuotationDocumentList(id);
        console.log("check Data here", data.data);
        commit(types.GET_QUOTATION_DOCUMENT_LIST, data.data);
    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_QUOTATION_DOCUMENT, false);
    }
}

export async function removeQuotationDocumentAction({ commit }, payload) {
    commit(types.LOADING_QUOTATION_DOCUMENT, true);
    try {
        await deleteQuotationDocument(payload);
        commit(types.REMOVE_QUOTATION_DOCUMENT, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_QUOTATION_DOCUMENT, false);
    }
}

export async function downloadQuotationDocumentAction({ commit }, payload) {
    commit(types.LOADING_QUOTATION_DOCUMENT, true);
    try {
        await downloadQuotationDocument(payload);
        commit(types.DOWNLOAD_QUOTATION_DOCUMENT, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_QUOTATION_DOCUMENT, false);
    }
}


export async function uploadQuotationDocumentAction({ commit }, {payload, referenceId = null, type = null, typeId = null}) {
    commit(types.LOADING_QUOTATION_DOCUMENT, true);
    try {
        await uploadQuotationDocument(payload, referenceId, type, typeId);
        commit(types.ADD_QUOTATION_DOCUMENT, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_QUOTATION_DOCUMENT, false);
    }
}


export async function uploadQuotationMultipleDocumentAction({ commit }, {payload, referenceId = null, type = null, typeId = null}) {
    commit(types.LOADING_QUOTATION_DOCUMENT, true);
    try {
        await uploadQuotationMultipleDocuments(payload, referenceId, type, typeId);
        commit(types.ADD_QUOTATION_MULTI_DOCUMENT, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_QUOTATION_DOCUMENT, false);
    }
}